import { render, staticRenderFns } from "./YandexSmartCapthca.vue?vue&type=template&id=436433b1&scoped=true"
import script from "./YandexSmartCapthca.vue?vue&type=script&lang=js"
export * from "./YandexSmartCapthca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436433b1",
  null
  
)

export default component.exports